import getUrlPath from '../utils/get-url-path';

function onUrl(url){
    var currentPath = getUrlPath();
    if (url.test(currentPath)){
        return Promise.resolve();
    } else {
        return Promise.reject();
    }
}

export default onUrl;


//////////////////
// WEBPACK FOOTER
// ./src/strategies/url-strategy.js
// module id = 11
// module chunks = 0